module.exports = __webpack_public_path__ + "static/media/Asif1.863d5b93.png";